<div class="card mt-1" [formGroup]="parentForm">
  <div class="card-header">
    Brand assignments
    <span class="float-right">
            <select class="form-control form-control-sm ml-2"
                    (change)="addRow(selectBrand.value)"
                    #selectBrand
                    appRequirePermission="admin.all,consent-definition.edit,consent-definition.all">
              <option value="0">Choose Brand</option>
              <option *ngFor="let key of productBrandsList$ | async" [ngValue]="key" [disabled]="isDisabledBrand(key)">{{ key }}</option>
            </select>
    </span>
  </div>
  <div class="card-body" formArrayName="brandAssignment">

    <div class="card m-2" *ngFor="let group of getFormControls.controls; trackBy: trackBy; let i=index" [formGroupName]="i">
      <div class="card-header">
        <button class="btn btn-danger btn-sm float-right" (click)="deleteRow(i)">Delete</button>
      </div>
      <div class="card-body">

        <div class="input-group mb-3 ml-1">
          <input type="text" class="form-control w-25" formControlName="brand" [readonly]="true">
          <select class="form-control ml-2 w-25"
                  (change)="addRowIdentifier(i,selectIdentifier.value)"
                  #selectIdentifier
                  appRequirePermission="admin.all,consent-definition.edit,consent-definition.all">
            <option value="0">Choose channel</option>
            <option *ngFor="let key of consentConfigurationIdentifierOptions"  [ngValue]="key" [disabled]="isDisabledIdentifier(i,key)">{{ key }}</option>
          </select>
        </div>
        <ng-container formArrayName="channelDetails">
          <div class="row">
          <div class="card m-2 w-25" *ngFor="let fees of getFormControlsIdentifier(group); trackBy: trackBy; let j=index" [formGroupName]="j">
            <div class="card-header">
              <button class="btn btn-danger btn-sm float-right" (click)="deleteRowIdentifier(i,j)">Delete</button>
            </div>
            <div class="card-body">
              <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="identifier" [readonly]="true">
              </div>
              <div class="input-group mb-3">
                <textarea formControlName="text" class="form-control" rows="10"></textarea>
              </div>

              <div class="input-group mb-2">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" formControlName="collect">
                  <label class="form-check-label">
                    Collect
                  </label>
                </div>

              </div>
            </div>
          </div>
          </div>
        </ng-container>

      </div>
    </div>

  </div>
</div>

